import { useEffect, useState } from "react";
import { Layout, SectionTitle } from "@/components/Layout";
import { api } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { ChevronDown } from "lucide-react";

export default function FAQPage() {
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(null);
  const { openWhatsApp } = useSettings();
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)); }, []);

  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-8 py-14">
        <SectionTitle label="Ajuda" title="Perguntas Frequentes"
          subtitle="Tire suas dúvidas rapidamente. Não achou o que procura? Fale com o suporte." />
        <div className="space-y-3">
          {faqs.map((f) => (
            <div key={f.id} className="ci-card overflow-hidden" data-testid={`faq-item-${f.id}`}>
              <button onClick={() => setOpen(open === f.id ? null : f.id)} data-testid={`faq-toggle-${f.id}`}
                className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 font-medium">
                {f.question}
                <ChevronDown className={`w-5 h-5 text-cyan-300 shrink-0 transition-transform ${open === f.id ? "rotate-180" : ""}`} />
              </button>
              {open === f.id && <div className="px-5 pb-5 text-gray-400 text-sm leading-relaxed" data-testid={`faq-answer-${f.id}`}>{f.answer}</div>}
            </div>
          ))}
        </div>
        <div className="mt-10 text-center">
          <button onClick={() => openWhatsApp("faq-page")} data-testid="faq-whatsapp-btn"
            className="ci-btn-wa inline-flex items-center gap-2 px-6 py-3 rounded-full text-white font-semibold hover:brightness-110 transition">
            💬 Falar com o suporte
          </button>
        </div>
      </div>
    </Layout>
  );
}
